// Back to top
var amountScrolled = 200;
var amountScrolledNav = 25;

$(window).scroll(function () {
  if ($(window).scrollTop() > amountScrolled) {
    $("button.back-to-top").addClass("show");
  } else {
    $("button.back-to-top").removeClass("show");
  }
});

$("button.back-to-top").click(function () {
  $("html, body").animate(
    {
      scrollTop: 0,
    },
    800
  );
  return false;
});

$(".text-icon").click(function () {
  $(this).parents(".main-acc").toggleClass("active_acc");
  $(this).parents(".main-acc").siblings().removeClass("active_acc");
});

$(document).ready(function () {
  var header = $("header");

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll > 0) {
      header.addClass("sticky");
    } else {
      header.removeClass("sticky");
    }
  });
});

// $(".cont_div").slick({
//   centerMode: true,
//   arrows: true,
//   centerPadding: "60px",
//   slidesToShow: 3,
//   prevArrow:
//     "<button type='button' class='slick-prev pull-left'><svg viewBox='0 0 14 10' fill='none' aria-hidden='true' focusable='false' class='icon icon-arrow' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z' fill='currentColor'></svg></button>",
//   nextArrow:
//     "<button type='button' class='slick-next pull-right'><svg viewBox='0 0 14 10' fill='none' aria-hidden='true' focusable='false' class='icon icon-arrow' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z' fill='currentColor'></svg></button>",
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: true,
//         centerMode: true,
//         centerPadding: "40px",
//         slidesToShow: 2,
//       },
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: true,
//         centerMode: true,
//         centerPadding: "40px",
//         slidesToShow: 1,
//       },
//     },
//   ],
// });

$(".image_column").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow:
    "<button type='button' class='slick-prev pull-left'><svg viewBox='0 0 14 10' fill='none' aria-hidden='true' focusable='false' class='icon icon-arrow' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z' fill='currentColor'></svg></button>",
  nextArrow:
    "<button type='button' class='slick-next pull-right'><svg viewBox='0 0 14 10' fill='none' aria-hidden='true' focusable='false' class='icon icon-arrow' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z' fill='currentColor'></svg></button>",
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        slidesToShow: 1,
      },
    },
  ],
});
